<template>
    <div class="towers-controls">
        <div class="controls-tabs">
            <button 
                v-on:click="towersSetRisk('easy')" 
                class="tab-button" 
                v-bind:class="{ 'tab-active': towersRisk === 'easy' }"
                v-bind:disabled="towersGame !== null && towersGame.state !== 'completed'"
            >
                <div class="tab-inner">Easy</div>
            </button>
            <button 
                v-on:click="towersSetRisk('medium')" 
                class="tab-button" 
                v-bind:class="{ 'tab-active': towersRisk === 'medium' }"
                v-bind:disabled="towersGame !== null && towersGame.state !== 'completed'"
            >
                <div class="tab-inner">Medium</div>
            </button>
            <button 
                v-on:click="towersSetRisk('hard')" 
                class="tab-button" 
                v-bind:class="{ 'tab-active': towersRisk === 'hard' }"
                v-bind:disabled="towersGame !== null && towersGame.state !== 'completed'"
            >
                <div class="tab-inner">Hard</div>
            </button>
        </div>
        <div class="controls-top">
            <div class="top-bet-section">
                <div class="bet-label">Your Bet</div>
                <div class="bet-input-container">
                    <div class="bet-icon-wrapper">
                        <IconCoin />
                    </div>
                    <div class="bet-separator"></div>
                    <div class="bet-value-display">
                        <input 
                            v-model="towersAmount" 
                            v-on:input="towersValidateInput" 
                            v-on:change="towersFormatInput"
                            type="text" 
                            class="bet-value-input"
                            placeholder="0.00"
                            v-bind:disabled="towersGame !== null && towersGame.state !== 'completed'" 
                        />
                    </div>
                    <div class="bet-quick-actions">
                        <button v-on:click="towersSetAmount('1/2')" class="quick-action-btn" v-bind:disabled="towersGame !== null && towersGame.state !== 'completed'">
                            1/2
                        </button>
                        <button v-on:click="towersSetAmount('2x')" class="quick-action-btn" v-bind:disabled="towersGame !== null && towersGame.state !== 'completed'">
                            2X
                        </button>
                        <button v-on:click="towersSetAmount('max')" class="quick-action-btn max-btn" v-bind:disabled="towersGame !== null && towersGame.state !== 'completed'">
                            MAX
                        </button>
                    </div>
                </div>
                <div class="bet-preset-buttons">
                    <button v-on:click="towersSetAmount('10')" class="preset-btn" v-bind:disabled="towersGame !== null && towersGame.state !== 'completed'">
                        10
                    </button>
                    <button v-on:click="towersSetAmount('100')" class="preset-btn" v-bind:disabled="towersGame !== null && towersGame.state !== 'completed'">
                        100
                    </button>
                    <button v-on:click="towersSetAmount('1000')" class="preset-btn" v-bind:disabled="towersGame !== null && towersGame.state !== 'completed'">
                        1.0k
                    </button>
                    <button v-on:click="towersSetAmount('10000')" class="preset-btn" v-bind:disabled="towersGame !== null && towersGame.state !== 'completed'">
                        10.0k
                    </button>
                </div>
            </div>
        </div>
        <button v-if="towersGame === null || towersGame.state === 'completed'" v-on:click="towersBetButton()"
            class="button-bet"
            v-bind:class="{ 'button-lose': towersGame !== null && towersGame.state === 'completed' && towersGame.payout <= 0 }"
            v-bind:disabled="socketSendLoading !== null">
            <div class="button-inner">
                <transition name="fade" mode="out-in">
                    <ButtonLoading v-if="socketSendLoading === 'TowersBet'" />
                    <div v-else class="inner-content">
                        <IconSkull
                            v-if="towersGame !== null && towersGame.state === 'completed' && towersGame.payout <= 0" />
                        <span>{{ towersGame !== null && towersGame.state === 'completed' && towersGame.payout <= 0
                            ? 'PLAY AGAIN' : 'PLACE BET' }}</span>
                    </div>
                </transition>
            </div>
        </button>
        <button v-else v-on:click="towersCashoutButton()" class="button-cashout"
            v-bind:disabled="socketSendLoading !== null">
            <div class="button-inner">
                <transition name="fade" mode="out-in">
                    <ButtonLoading v-if="socketSendLoading === 'TowersCashout'" />
                    <div v-else class="inner-content">
                        CASHOUT
                        <div class="content-amount">
                            <IconCoin />
                            <div class="amount-value">
                                <span>{{ towersFormatValue(towersGetCashoutAmount).split('.')[0] }}</span>.{{
                                    towersFormatValue(towersGetCashoutAmount).split('.')[1] }}
                            </div>
                        </div>
                    </div>
                </transition>
            </div>
        </button>
        <button v-if="towersGame !== null && towersGame.state !== 'completed'" v-on:click="towersRevealButton()"
            class="button-random" v-bind:disabled="socketSendLoading !== null">
            <div class="button-inner">
                <transition name="fade" mode="out-in">
                    <ButtonLoading v-if="socketSendLoading === 'TowersReveal'" />
                    <div v-else class="inner-content">
                        RANDOM PICK
                    </div>
                </transition>
            </div>
        </button>
    </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import ButtonLoading from '@/components/ButtonLoading';
import IconSkull from '@/components/icons/IconSkull';
import IconCoin from '@/components/icons/IconCoin';

export default {
    name: 'TowersControls',
    components: {
        ButtonLoading,
        IconSkull,
        IconCoin
    },
    data() {
        return {
            towersAmount: null
        }
    },
    methods: {
        ...mapActions([
            'notificationShow',
            'soundSetTowers',
            'modalsSetShow',
            'towersSetRisk',
            'towersSendBetSocket',
            'towersSendRevealSocket',
            'towersSendCashoutSocket'
        ]),
        towersFormatValue(value) {
            return parseFloat(value).toFixed(2).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
        },
        towersValidateInput() {
            if(this.towersAmount === null || this.towersAmount === undefined) {
                this.towersAmount = '';
                return;
            }
            const value = String(this.towersAmount);
            if(value === '') {
                return;
            }
            this.towersAmount = value.replace(',', '.').replace(/[^\d.]/g, '');
            this.towersAmount = this.towersAmount.indexOf('.') >= 0 ? this.towersAmount.substr(0, this.towersAmount.indexOf('.')) + '.' + this.towersAmount.substr((this.towersAmount.indexOf('.') + 1), 2).replace('.', '') : this.towersAmount;
        },
        towersFormatInput() {
            if(this.towersAmount === null || this.towersAmount === '' || this.towersAmount === undefined) {
                this.towersAmount = '0.00';
                return;
            }
            this.towersAmount = Number(this.towersAmount).toFixed(2);
        },
        towersSetAmount(action) {
            if(action === 'clear') {
                this.towersAmount = '';
                return;
            }

            let amount = this.towersAmount === null || this.towersAmount === '' || isNaN(parseFloat(this.towersAmount)) ? 0 : parseFloat(this.towersAmount);
            const balance = this.authUser.user !== null ? this.authUser.user.balance : 0;

            if (action === 'min') {
                amount = 0.01;
            } else if (action === '1/2') {
                if(amount === 0) {
                    amount = 0.01;
                } else {
                    amount = amount / 2;
                }
            } else if (action === '2x') {
                if(amount === 0) {
                    amount = 0.01;
                } else {
                    amount = amount * 2;
                }
            } else if (action === 'max') {
                amount = balance;
            } else if (action === '10') {
                amount = 10;
            } else if (action === '100') {
                amount = 100;
            } else if (action === '1000') {
                amount = 1000;
            } else if (action === '10000') {
                amount = 10000;
            }

            // Ensure amount doesn't exceed balance
            if(amount > balance && balance > 0) {
                amount = balance;
            }

            // Ensure minimum amount
            if(amount < 0.01 && action !== 'min' && action !== '1/2' && action !== '2x') {
                amount = 0.01;
            }

            // Format to 2 decimal places
            this.towersAmount = parseFloat(amount).toFixed(2);
        },
        towersBetButton() {
            if (!this.authenticated) {
                this.$root.$emit('open-signin-modal-app');
                return;
            }

            const amount = parseFloat(this.towersAmount) || 0;

            if (isNaN(amount) === true || amount <= 0) {
                this.notificationShow({ type: 'error', message: 'Your entered bet amount is invalid.' });
                return;
            }

            const data = { amount: amount, risk: this.towersRisk };
            this.towersSendBetSocket(data);
        },
        towersRevealButton() {
            // Determine the number of tiles based on the difficulty
            const tilesCount = this.towersGame.risk === 'medium' ? 2 : 3;

            // Pick a random tile (0-indexed)
            const tile = Math.floor(Math.random() * tilesCount);

            const data = { tile: tile };
            this.towersSendRevealSocket(data);
        },
        towersCashoutButton() {
            const data = {};
            this.towersSendCashoutSocket(data);
        },
        towersFairButton() {
            if (!this.authenticated) {
                this.notificationShow({ type: 'error', message: 'Please sign in to perform this action.' });
                return;
            }

            this.modalsSetShow('FairSeed')
        },
        towersMuteButton() {
            if (this.soundTowers === 1) {
                this.soundSetTowers(0);
            } else {
                this.soundSetTowers(1);
            }
        }
    },
    computed: {
        ...mapGetters([
            'socketSendLoading',
            'soundTowers',
            'authUser',
            'authenticated',
            'towersRisk',
            'towersGame'
        ]),
        towersGetCashoutAmount() {
            const multiplierPerRow = this.towersGame.risk === 'easy' ? 1.425 : this.towersGame.risk === 'medium' ? 1.90 : 2.85;
            return this.towersGame.amount * Math.pow(multiplierPerRow, this.towersGame.revealed.length);
        }
    }
}
</script>

<style scoped>
.towers-controls {
    width: 100%;
    margin-top: 15px;
    padding: 0 30px;
    position: relative;
    overflow: visible;
}


.towers-controls .controls-tabs {
    width: 100%;
    display: flex;
    gap: 0;
    margin-bottom: 20px;
    position: relative;
    background: var(--bg-blue-dark);
    border: 1px solid rgba(255, 255, 255, 0.1);
    border-radius: 100px;
    padding: 2px;
}

.towers-controls .tab-button {
    flex: 1;
    height: 36px;
    position: relative;
    padding: 0;
    border: none;
    background: transparent;
    cursor: pointer;
    transition: all 0.3s ease;
    z-index: 1;
}

.towers-controls .tab-button:disabled {
    cursor: not-allowed;
    opacity: 0.5;
}

.towers-controls .tab-button .tab-inner {
    width: 100%;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 13px;
    font-weight: 700;
    color: #ffffff;
    background: transparent;
    border: none;
    border-radius: 100px;
    transition: all 0.3s ease;
    text-transform: uppercase;
    position: relative;
    z-index: 2;
}

.towers-controls .tab-button.tab-active .tab-inner {
    color: #ffffff;
    background: var(--gradient-purple-btn-bg);
    border: none;
}

.towers-controls .tab-button:not(:disabled):hover .tab-inner {
    color: #ffffff;
    background: transparent;
}

.towers-controls .tab-button.tab-active:not(:disabled):hover .tab-inner {
    color: #ffffff;
    background: var(--gradient-purple-btn-bg);
}

.towers-controls .controls-top {
    width: 100%;
    display: flex;
    flex-direction: column;
}

.towers-controls .top-bet-section {
    width: 100%;
    margin-bottom: 20px;
}

.towers-controls .bet-label {
    font-size: 12px;
    font-weight: 600;
    color: #ffffff;
    margin-bottom: 8px;
}

.towers-controls .bet-input-container {
    width: 100%;
    height: 60px;
    display: flex;
    align-items: center;
    background: var(--bg-blue-dark);
    border-radius: 100px;
    padding: 0 15px;
    gap: 15px;
}

.towers-controls .bet-icon-wrapper {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 40px;
    height: 40px;
    flex-shrink: 0;
}

.towers-controls .bet-icon-wrapper svg {
    width: 24px;
    height: 24px;
}

.towers-controls .bet-separator {
    width: 1px;
    height: 30px;
    background: rgba(255, 255, 255, 0.2);
    flex-shrink: 0;
}

.towers-controls .bet-value-display {
    flex: 1;
    display: flex;
    align-items: center;
}

.towers-controls .bet-value-input {
    width: 100%;
    background: transparent;
    border: none;
    outline: none;
    font-size: 16px;
    font-weight: 600;
    color: #ffffff;
    padding: 0;
    text-align: left;
}

.towers-controls .bet-value-input:disabled {
    cursor: not-allowed;
    opacity: 0.6;
}

.towers-controls .bet-value-input::placeholder {
    color: rgba(255, 255, 255, 0.5);
}

.towers-controls .bet-quick-actions {
    display: flex;
    align-items: center;
    gap: 8px;
    flex-shrink: 0;
}

.towers-controls .quick-action-btn {
    min-width: 32px;
    height: 28px;
    padding: 0 8px;
    display: flex;
    align-items: center;
    justify-content: center;
    background: transparent;
    border: 1px solid rgba(255, 255, 255, 0.2);
    border-radius: 16px;
    color: #ffffff;
    font-size: 11px;
    font-weight: 600;
    cursor: pointer;
    transition: all 0.2s ease;
}

.towers-controls .quick-action-btn:hover:not(:disabled) {
    background: rgba(255, 255, 255, 0.1);
    border-color: rgba(255, 255, 255, 0.3);
}

.towers-controls .quick-action-btn:disabled {
    cursor: not-allowed;
    opacity: 0.5;
}

.towers-controls .quick-action-btn.max-btn {
    border-radius: 6px;
    padding: 0 10px;
}

.towers-controls .bet-preset-buttons {
    width: 100%;
    display: flex;
    gap: 8px;
    margin-top: 12px;
}

.towers-controls .preset-btn {
    flex: 1;
    height: 40px;
    display: flex;
    align-items: center;
    justify-content: center;
    background: var(--bg-blue-dark);
    border: 1px solid rgba(255, 255, 255, 0.1);
    border-radius: 47px;
    color: #ffffff;
    font-size: 13px;
    font-weight: 600;
    cursor: pointer;
    transition: all 0.2s ease;
}

.towers-controls .preset-btn:hover:not(:disabled) {
    background: rgba(255, 255, 255, 0.05);
    border-color: rgba(255, 255, 255, 0.2);
}

.towers-controls .preset-btn:disabled {
    cursor: not-allowed;
    opacity: 0.5;
}

.towers-controls button.button-bet,
.towers-controls button.button-cashout,
.towers-controls button.button-random {
    width: 100%;
    height: 44px;
    position: relative;
    z-index: 1;
    border: none;
    background: transparent;
    cursor: pointer;
    outline: none;
}

.towers-controls button.button-bet:disabled,
.towers-controls button.button-cashout:disabled,
.towers-controls button.button-random:disabled {
    cursor: not-allowed;
    opacity: 0.6;
}

.towers-controls button.button-bet,
.towers-controls button.button-cashout {
    margin-top: 25px;
    padding: 0;
    filter: drop-shadow(0px 2px 2px rgba(0, 0, 0, 0.1));
}

.towers-controls button.button-random {
    margin-top: 13px;
    padding: 0;
    filter: drop-shadow(0px 2px 2px rgba(0, 0, 0, 0.1));
}

.towers-controls button.button-cashout::after {
    content: '';
    width: calc(100% - 2px);
    height: calc(100% - 2px);
    position: absolute;
    top: 1px;
    left: 1px;
    background-color: #2a2a2a;
    border-radius: 12px;
    z-index: -1;
}

.towers-controls button.button-bet .button-inner,
.towers-controls button.button-cashout .button-inner,
.towers-controls button.button-random .button-inner {
    width: 100%;
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    border-radius: 100px;
    background: var(--gradient-button-bg);
    box-sizing: border-box;
    transition: opacity 0.2s ease;
    position: relative;
    color: #ffffff;
}

.towers-controls button.button-bet .button-inner {
    background: var(--gradient-purple-btn-bg);
}

.towers-controls button.button-cashout .button-inner {
    background: var(--gradient-button-bg);
}

.towers-controls button.button-random .button-inner {
    font-size: 14px;
    font-weight: 700;
    color: var(--accent-btn-txt-color);
    background: var(--gradient-button-bg);
}

.towers-controls button.button-bet .button-loading.fade-leave-active,
.towers-controls button.button-cashout .button-loading.fade-leave-active,
.towers-controls button.button-random .button-loading.fade-leave-active {
    transition: opacity 0.1s;
}

.towers-controls button.button-bet .button-loading.fade-leave-to,
.towers-controls button.button-cashout .button-loading.fade-leave-to,
.towers-controls button.button-random .button-loading.fade-leave-to {
    opacity: 0;
}

.towers-controls button.button-bet .inner-content.fade-enter-active,
.towers-controls button.button-cashout .inner-content.fade-enter-active,
.towers-controls button.button-random .inner-content.fade-enter-active {
    transition: opacity 0.1s;
}

.towers-controls button.button-bet .inner-content.fade-enter,
.towers-controls button.button-cashout .inner-content.fade-enter,
.towers-controls button.button-random .inner-content.fade-enter {
    opacity: 0;
}

.towers-controls button.button-bet .inner-content,
.towers-controls button.button-cashout .inner-content,
.towers-controls button.button-random .inner-content {
    display: flex;
    align-items: center;
    font-size: 15px;
    font-weight: 800;
    color: #ffffff;
}

.towers-controls button.button-bet.button-lose .inner-content {
    color: #F55046;
    text-shadow: 0px 0px 32px rgba(238, 29, 17, 0.28);
}

.towers-controls button.button-bet.button-lose .inner-content svg {
    width: 12px;
    margin-right: 8px;
}

.towers-controls button.button-random .button-inner svg {
    width: 16px;
    height: 16px;
    margin-right: 8px;
    flex-shrink: 0;
}

.towers-controls button.button-cashout .content-amount {
    display: flex;
    align-items: center;
    margin-left: 9px;
}

.towers-controls button.button-cashout .content-amount svg {
    width: 13px;
    height: 13px;
    margin-right: 5px;
}

.towers-controls button.button-cashout .amount-value {
    font-size: 10px;
    font-weight: 600;
    color: #bbbfd0;
}

.towers-controls button.button-cashout .amount-value span {
    font-size: 13px;
    font-weight: 800;
    color: var(--accent-btn-txt-color);
}


@media only screen and (max-width: 850px) {
    .towers-controls {
        display: flex;
        flex-direction: column;
    }

    /* Reorder elements on mobile: PLACE BET at top, controls-tabs at bottom */
    .towers-controls .controls-tabs {
        order: 99;
        margin-top: 15px;
    }

    .towers-controls .controls-top {
        order: 2;
    }

    .towers-controls button.button-bet,
    .towers-controls button.button-cashout {
        order: 1;
        margin-top: 0;
        margin-bottom: 15px;
    }

    .towers-controls button.button-random {
        order: 3;
        margin-top: 10px;
    }
}

@media only screen and (max-width: 575px) {
}

@media only screen and (max-width: 550px) {

    .towers-controls {
        padding: 0 15px;
    }


    .towers-controls button.button-bet,
    .towers-controls button.button-cashout,
    .towers-controls button.button-random {
        width: 100%;
    }

}

@media only screen and (max-width: 425px) {
}

@media only screen and (max-width: 350px) {
}
</style>